import React, { useContext, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import {
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
  TextField,
} from '@mui/material';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { poppins500, poppins400 } from 'theme/common.style';
import Swal from 'sweetalert2';
import EnhancedTable from 'component/BuyerRegistration/ForwardCounterOfferTable';
import { forwardOfferToBuyer, Moxoseparationinlisting } from 'api/apiService';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import Loading from 'assets/images/loading.png';

function ForwardCounterOfferPopup(props) {
  const {
    getListInfo,
    multipleChkCounter,
    open,
    onClose,
    selectedCheckboxes,
    setSelectedCheckboxes,
    setBuyerRegisterCheckBox,
    VendorForward,
    formattedOfferPriceVendor,
    offerPriceVendor,
    formattedlatestcounterOfferPrice,
    vendorCounterPrice,
    formattedVendorCounterPrice,
    mobileView,
    propertyDetails,
    counterOfferBuyerId,
    address,
    offerUniqueId,
    selectedrowbuyername,
    buyerOfferPrice,
    setShareMarketPlace,
    sharedToMarket,
    setBuyerRegisterChecked,
  } = props;
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const data = props?.profileDetails?.PropertyDetails?.vendorStatus;
  const offerPrice =
    props?.profileDetails?.PropertyDetails?.vendorStatus?.price;
  const { forwardcountertobuyer, setForwardCountertobuyer } =
    useContext(LoaderContext);
  const [loader, setLoader] = useState(false);
  const [messageToBuyer, setMessageToBuyer] = useState('');
  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const handleCancelClick = () => {
    setForwardOfferCheckList([]);
    setForwardCountertobuyer(false);
    if (!VendorForward) {
      setSelectedCheckboxes([]);
      setBuyerRegisterCheckBox([]);
      setBuyerRegisterChecked(false);
    }
    onClose();
  };

  const [forwardOfferCheckList, setForwardOfferCheckList] = useState(
    selectedCheckboxes || []
  );

  useEffect(() => {
    if (selectedCheckboxes) {
      setForwardOfferCheckList(selectedCheckboxes);
    }
  }, [selectedCheckboxes]);

  const [selectedUserNames, setSelectedUserNames] = useState([]);
  const [selectedUserSurNames, setSelectedUserSurNames] = useState([]);
  const [selectedOfferUniqueIds, setSelectedOfferUniqueIds] = useState([]);

  const [disableForward, setDisableForward] = useState(false);
  const forwardOfferToBuyerFunc = () => {
    setLoader(true);
    setDisableForward(true);
    let offerId;

    const filteredOfferCheckList = forwardOfferCheckList.filter(
      (element) => element !== ''
    );

    const selectedOfferUniqueId = selectedOfferUniqueIds.filter(
      (element) => typeof element == 'string' && element.trim() !== ''
    );

    const offerIds = selectedOfferUniqueId
      .filter((id) => id.trim() !== '')
      .map((id) => ({ offerUniqueId: id }));

    const selectedUserName = selectedUserNames.filter(
      (element) => element != ''
    );

    const selectedUserSurName = selectedUserSurNames.filter(
      (element) => element != ''
    );

    const combinedNames = selectedUserName.map(
      (name, index) => `- ${name} ${selectedUserSurName[index]}`
    );

    let statusToDisplay = 'Counter Offer';

    const vendorCounterPriceInput = VendorForward
      ? formattedVendorCounterPrice
      : multipleChkCounter
      ? formattedlatestcounterOfferPrice
      : offerPriceVendor;

    let input = {
      offerUniqueId: selectedOfferUniqueId.map((id) => ({ offerUniqueId: id })),
      messageToBuyer: messageToBuyer,
      offerStatus: statusToDisplay,
      vendorCounterPrice: vendorCounterPriceInput,
    };

    const formattedCombinedNames = combinedNames.join('<br>');
    const isScrollable = combinedNames.length > 5;
    const priceToShow = VendorForward
      ? vendorCounterPrice
      : multipleChkCounter && !mobileView
      ? props?.profileDetails?.latestcounterOfferPrice
      : multipleChkCounter && mobileView
      ? propertyDetails?.latestcounterOfferPrice
      : formattedOfferPriceVendor;
    const forwardMessage =
      filteredOfferCheckList.length > 1
        ? `Counter Offer <span><b style={{ fontFamily: "Poppins", fontWeight: 550, color:"#666666"}}>
          ${priceToShow}</b></span> has been forwarded to the selected Buyers: <br> ${
            isScrollable
              ? `<div style="height: 130px; overflow-y: scroll; -webkit-overflow-scrolling: touch; scrollbar-width: auto; scrollbar-color: #888 #f1f1f1;"><span><b style={{ fontFamily: "Poppins", fontWeight: 550, color:"#666666"}}>${formattedCombinedNames}</b></span></div>`
              : `<span><b style={{ fontFamily: "Poppins", fontWeight: 550, color:"#666666"}}>${formattedCombinedNames}</b></span>`
          }`
        : `Counter Offer <span><b style={{ fontFamily: "Poppins", fontWeight: 550, color:"#666666"}}>${priceToShow}</b></span> has been forwarded to the selected Buyer:<br> <span><b style={{ fontFamily: "Poppins", fontWeight: 550, color:"#666666"}}>${combinedNames[0]}</b></span>`;

    forwardOfferToBuyer(input)
      .then((res) => {
        if (res?.status == '1') {
          if (isNotEmptyArray(res?.dataForBuyerAck))
            Moxoseparationinlisting(
              'offerSharingToBuyer',
              res?.dataForBuyerAck
            );
          setLoader(false);
          Swal.fire({
            title: res?.heading ? 'Forwarded Successfully' : 'Success',
            html: `<div style="text-align: left;">${forwardMessage}</div>`,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
            backdrop: false,
            allowOutsideClick: false,
          }).then((result) => {
            setDisableForward(false);
            if (result.isConfirmed) {
              {
                sharedToMarket != 1 && setShareMarketPlace(true);
              }
              setTimeout(() => {
                onClose();
              }, 100);
              setForwardOfferCheckList([]);
              setSelectedUserNames([]);
              getListInfo();
              if (multipleChkCounter) {
                setSelectedCheckboxes([]);
                setBuyerRegisterCheckBox([]);
                setBuyerRegisterChecked(false);
              }
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          setLoader(false);
          onClose();
          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            setDisableForward(false);
            if (result.isConfirmed) {
              setForwardCountertobuyer(!forwardcountertobuyer);
              setForwardOfferCheckList([]);
              if (multipleChkCounter) {
                setSelectedCheckboxes([]);
                setBuyerRegisterCheckBox([]);
                setBuyerRegisterChecked(false);
              }
            } else if (result.isDenied) {
              return;
            }
          });
        }
      })
      .catch(() => {
        setLoader(false);
        setDisableForward(false);
      });
  };

  useEffect(() => {
    if (loader) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loader]);

  const headCells = [
    {
      id: 'name',
      numeric: false,
      disablePadding: true,
      label: 'Name',
    },
    {
      id: 'contact',
      numeric: true,
      disablePadding: false,
      label: 'Contact',
    },
    {
      id: 'buyerreadlines',
      numeric: true,
      disablePadding: false,
      label: 'Buyer Readlines',
    },
    {
      id: 'status',
      numeric: true,
      disablePadding: false,
      label: 'Status',
    },
    {
      id: 'offer',
      numeric: true,
      disablePadding: false,
      label: 'Offer',
    },
    {
      id: 'noofoffer',
      numeric: true,
      disablePadding: false,
      label: 'Number of offers',
    },
    {
      id: 'propertyrating',
      numeric: true,
      disablePadding: false,
      label: 'Property Rating',
    },
    {
      id: 'exp',
      numeric: true,
      disablePadding: false,
      label: 'Exp',
    },
    {
      id: 'profile',
      numeric: true,
      disablePadding: false,
      label: 'Profile',
    },
    {
      id: 'profile',
      numeric: true,
      disablePadding: false,
      label: '',
    },
    {
      id: 'action',
      numeric: true,
      disablePadding: false,
      label: 'Action Required',
    },
  ];

  const isInactiveStatus = (status) => ['Pause', 'End'].includes(status);

  const isDisabled =
    isInactiveStatus(props?.profileDetails?.PropertyDetails?.timerStatus) ||
    isInactiveStatus(propertyDetails?.PropertyDetails?.timerStatus) ||
    !forwardOfferCheckList?.length ||
    loader ||
    disableForward;

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : matchesmd ? 'auto' : '650px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchesmd ? '30px 20px' : '30px',
            marginBottom: matchessm ? '87px' : '',
          },
        }}
      >
        <Grid container sx={{ overflowY: 'scroll', position: 'relative' }}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchesmd ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {' '}
              {mobileView
                ? propertyDetails?.PropertyDetails?.propertyAddress?.streetName
                : props?.profileDetails?.PropertyDetails?.propertyAddress
                    ?.streetName}
              &nbsp;
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchesmd ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Forward Counter Offer to Buyers
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchesmd ? '12px' : '16px',
                color: '#666666',
              }}
            >
              Forward{' '}
              <Typography component="span">
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    color: '#666666',
                  }}
                >
                  {mobileView
                    ? (() => {
                        const primaryOwner =
                          propertyDetails?.PropertyDetails?.propertyOwnerDetails?.find(
                            (owner) => owner.isPrimary === 1
                          );
                        return primaryOwner
                          ? `${primaryOwner.user?.userName} ${primaryOwner.user?.userSurName}`
                          : '';
                      })()
                    : (() => {
                        const primaryOwner =
                          props?.profileDetails?.PropertyDetails?.propertyOwnerDetails?.find(
                            (owner) => owner.isPrimary === 1
                          );
                        return primaryOwner
                          ? `${primaryOwner.user?.userName} ${primaryOwner.user?.userSurName}`
                          : '';
                      })()}
                </b>
              </Typography>
              's counter offer{' '}
              <Typography component="span">
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    color: '#666666',
                  }}
                >
                  {VendorForward
                    ? vendorCounterPrice
                    : multipleChkCounter && !mobileView
                    ? props?.profileDetails?.latestcounterOfferPrice
                    : multipleChkCounter && mobileView
                    ? propertyDetails?.latestcounterOfferPrice
                    : formattedOfferPriceVendor}
                </b>
              </Typography>{' '}
              to selected buyers.
            </Typography>
          </Grid>

          <Grid
            item
            xs={matchessm ? 6 : 4.5}
            textAlign={'left'}
            paddingTop={matchesmd ? '10px' : '30px'}
          >
            <Typography
              sx={{ ...poppins500, fontSize: matchesmd ? '14px' : '18px' }}
              whiteSpace={'nowrap'}
            >
              Vendor Offer :{' '}
            </Typography>
          </Grid>
          <Grid
            item
            xs={matchessm ? 6 : 7.5}
            paddingLeft={'20px'}
            paddingTop={matchesmd ? '10px' : '30px'}
          >
            <Typography
              sx={{ ...poppins400, fontSize: matchesmd ? '14px' : '18px' }}
            >
              {VendorForward
                ? vendorCounterPrice
                : multipleChkCounter && !mobileView
                ? props?.profileDetails?.latestcounterOfferPrice
                : multipleChkCounter && mobileView
                ? propertyDetails?.latestcounterOfferPrice
                : formattedOfferPriceVendor}
            </Typography>
          </Grid>

          <Grid
            item
            xs={matchessm ? 12 : 4.5}
            justifyContent={'left'}
            paddingTop={matchesmd ? '10px' : '30px'}
            display={'flex'}
            alignItems={'start'}
          >
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchesmd ? '14px' : '18px',
                textAlign: 'right',
              }}
              whiteSpace={'nowrap'}
            >
              Message to Buyer :{' '}
            </Typography>
          </Grid>

          <Grid
            item
            xs={matchessm ? 12 : 7.5}
            paddingLeft={matchessm ? null : '20px'}
            paddingTop={matchesmd ? '10px' : '25px'}
            display={'flex'}
            alignItems={'center'}
          >
            <Typography
              width={'100%'}
              sx={{
                display: 'flex',
                alignItems: 'left',
                justifyContent: 'left',
              }}
            >
              <TextField
                fullWidth
                multiline
                rows={matchessm ? 2 : 4}
                variant="standard"
                sx={{
                  color: '#000000',
                  borderRadius: '5px',
                  padding: '5px',
                  border: '1px solid #F0F0F0',
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%',
                }}
                placeholder="Text message"
                type="text"
                name="name"
                inputProps={{ style: { fontFamily: 'poppins' } }}
                InputProps={{ disableUnderline: 'true' }}
                onChange={(e) => setMessageToBuyer(e.target.value)}
              />
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            paddingTop={matchesmd ? '10px' : '30px'}
            sx={{
              overflowX: 'scroll !important',
              scrollbarWidth: '2px !important',
            }}
          >
            <EnhancedTable
              buyeroffer={false}
              headCells={headCells}
              tableData={
                mobileView
                  ? propertyDetails?.BuyerRegisterDetails
                  : props?.profileDetails?.BuyerRegisterDetails
              }
              onClick={props.onClick}
              id={props.id}
              vendorstatustable={true}
              forwardbuyernotify={true}
              setForwardOfferCheckList={setForwardOfferCheckList}
              forwardOfferCheckList={forwardOfferCheckList}
              selectedUserNames={selectedUserNames}
              setSelectedUserNames={setSelectedUserNames}
              selectedUserSurNames={selectedUserSurNames}
              setSelectedUserSurNames={setSelectedUserSurNames}
              selectedCheckboxes={selectedCheckboxes}
              selectedOfferUniqueIds={selectedOfferUniqueIds}
              setSelectedOfferUniqueIds={setSelectedOfferUniqueIds}
              counterOfferForwardHistory={
                props?.profileDetails?.counterOfferForwardedHistory
              }
              mobileView={mobileView}
              multipleChkCounter={multipleChkCounter}
              counterOfferBuyerId={counterOfferBuyerId}
              address={address}
              VendorForward={VendorForward}
              vendorCounterPrice={vendorCounterPrice}
              formattedOfferPriceVendor={formattedOfferPriceVendor}
              privateOfferDetails={
                mobileView
                  ? propertyDetails?.PropertyDetails?.PropertyDetails
                      ?.privateOfferDetails
                  : props?.profileDetails?.PropertyDetails?.privateOfferDetails
              }
              fullPropertyDetails={
                mobileView
                  ? propertyDetails?.PropertyDetails
                  : props?.profileDetails?.PropertyDetails
              }
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent={'flex-end'}
          gap={2}
          marginTop={2}
          sx={{ position: 'sticky', bottom: '0' }}
        >
          <Grid item>
            <Button
              disabled={loader || disableForward}
              variant="outlined"
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
              }}
              onClick={handleCancelClick}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              disabled={isDisabled}
              onClick={() => forwardOfferToBuyerFunc({ offerPrice })}
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#FFFFFF',
                fontWeight: '400',
                fontFamily: 'Poppins',
                background: '#4CA4D6',
                borderRadius: '5px',
                textTransform: 'none',
                cursor:
                  forwardOfferCheckList?.length === 0 ? 'no-drop' : 'pointer',
              }}
            >
              Forward
            </Button>
          </Grid>
          {loader && (
            <Grid item>
              <img
                alt="Logo"
                src={Loading}
                className="loaderImage"
                style={{ height: '40px', width: '40px' }}
              />
            </Grid>
          )}
        </Grid>
      </Dialog>
    </React.Fragment>
  );
}

export default ForwardCounterOfferPopup;
